/**
 * Utilities for reading and persisting Meta _fbc and _fbp cookies.
 * These are critical for Conversions API Event Match Quality.
 *
 * _fbp: Set by Meta Pixel SDK — identifies the browser.
 * _fbc: Set from fbclid URL param — identifies the ad click.
 */

export function getCookie(name: string): string {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return match ? match.split("=").slice(1).join("=") : "";
}

export function setCookie(name: string, value: string, days: number): void {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getFbp(): string {
  return getCookie("_fbp");
}

export function getFbc(): string {
  const cookie = getCookie("_fbc");
  if (cookie) return cookie;

  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get("fbclid");
  if (fbclid) {
    return `fb.1.${Date.now()}.${fbclid}`;
  }

  return "";
}

export function persistFbcFromUrl(): void {
  if (getCookie("_fbc")) return;

  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get("fbclid");
  if (fbclid) {
    const fbc = `fb.1.${Date.now()}.${fbclid}`;
    setCookie("_fbc", fbc, 90);
  }
}
